export default "__VITE_ASSET__CSTf3or$__"